import * as React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {Link} from 'react-router-dom';

interface TopbarNavProps {
    sidebar: any;
    dispatch: (action: any) => (any);
}

const mapStateToProps = (state) => {
    const stateProps = {
        sidebar: state.sidebar
    };
    return stateProps;
};

class TopbarNav extends React.PureComponent<TopbarNavProps & RouteComponentProps<any>, {}> {

    public render() {
        return (
            <nav className='topbar__nav'>
                <Link className='topbar__nav-link' to='/home'>Portada</Link>
                <Link className='topbar__nav-link' to='/liquidacion'>Liquidación</Link>
                <Link className='topbar__nav-link' to='/almacen'>Almacén</Link>
                <Link className='topbar__nav-link' to='/comprobantes'>Comprobantes</Link>
            </nav>
        )
    }
}

export default withRouter(connect(mapStateToProps)(TopbarNav));


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar_nav/topbar_nav.tsx